<ng-template #defaultPortfolioSelector>
  <div mat-dialog-title class="mat-dialog-title mb-0">
    <span class="dialog-title-label">{{ rendering.fields.Title.value }}</span>
    <button
      *ngIf="rendering.fields.HasCloseButtonInHeader.value"
      (click)="onClose()"
      class="btn btn-default"
    >
      <i class="icon-close"></i>
    </button>
  </div>
  <div mat-dialog-content class="mat-dialog-content pb-0 pl-0 pr-0">
    <form #defaultPortfolioSelectorForm="ngForm">
      <table class="table table-striped">
        <colgroup>
          <col class="w-sm-10" />
          <col class="w-sm-50" />
          <col class="w-sm-50" />
        </colgroup>
        <thead>
          <tr>
            <th
              class="border-top-0"
              *ngFor="let item of tableColumns.fields.items"
            >
              <span *scText="item.fields.label"></span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let portfolio of portfolios">
            <td>
              <mat-radio-group
                (change)="setDefault(portfolio)"
                [(ngModel)]="portfolio.isDefault"
                [ngModelOptions]="{ standalone: true }"
                class="ab-radio-group"
              >
                <mat-radio-button
                  class="ab-radio"
                  [value]="true"
                ></mat-radio-button>
              </mat-radio-group>
            </td>
            <td>{{ portfolio.name }}</td>
            <td>
              <ng-container
                *ngTemplateOutlet="
                  defaultTemplate;
                  context: {
                    defaultAccount: getDefaultAccount(portfolio)
                  }
                "
              ></ng-container>
              <ng-template #defaultTemplate let-defaultAccount="defaultAccount">
                <mat-select
                  [value]="defaultAccount"
                  (selectionChange)="selectedAccountChange($event)"
                  placeholder="Select default account"
                  hideSingleSelectionIndicator
                >
                  <ng-container *ngFor="let account of accounts">
                    <mat-option
                      [value]="account"
                      *ngIf="account.portfolioId === portfolio.id"
                    >
                      {{ account?.accountName }} -
                      {{
                        account?.availableBalance?.currencyCode
                          | abCurrencySymbol
                      }}
                      <span
                        [innerHTML]="
                          account.availableBalance?.amount | supFraction
                        "
                      ></span>
                      -
                      {{ account?.accountNumber }}
                    </mat-option>
                  </ng-container>
                </mat-select>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
    <div class="loader-bar" [hidden]="!isLoading"></div>
    <div class="help-text">
      <i class="icon-exclamation-triangle mr-1"></i>
      {{ rendering.fields.BodyText.value }}
    </div>
  </div>
  <div mat-dialog-actions class="mat-dialog-actions">
    <ng-container>
      <button
        class="btn btn-primary btn-mid btn-block btn-md-block-none"
        (click)="submit()"
        [disabled]="defaultPortfolioSelectorForm.invalid"
        abButtonLoader
      >
        <span *scRichText="rendering.fields.SubmitButtonLabel"></span>
      </button>
    </ng-container>
    <ng-container *ngIf="rendering.fields.CancelButtonLabel.value !== ''">
      <button
        class="btn btn-link btn-with-icon btn-block btn-md-block-none"
        (click)="onClose()"
      >
        <span *scText="rendering.fields.CancelButtonLabel"></span>
      </button>
    </ng-container>
  </div>
</ng-template>
